import {
  AppBar,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import SideNavContent from "@components/Nav/SideNavContent";

interface SideNavProps {
  mobileOpen: boolean;
  onMobileClose: () => void;
}

const SideNav = ({ mobileOpen, onMobileClose }: SideNavProps) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        data-testid="side-nav-drawer"
      >
        <SideNavContent
          isMobile
          location={location}
          onNavClick={onMobileClose}
        />
      </Drawer>
    );
  }

  return (
    <AppBar
      className="main flex-col flex text-center h-full mx-0 p-0 pt-8 justify-center w-48"
      data-testid="side-nav-component"
      position="static"
      //TODO: - get rid of these variants
      variant={"sideNav" as never}
    >
      <SideNavContent location={location} />
    </AppBar>
  );
};

export default SideNav;
